export const SocTwoFrameworkId = '1239155705';
export const SocTwoFrameworkName = 'SOC 2';
